import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils/cn";
import { memo } from "react";

interface ProjectSchedulesDialogHeaderComponentProps {
  title: string;
  variant?: "destructive";
}

const ProjectSchedulesDialogHeaderComponent = ({
  title,
  variant,
}: ProjectSchedulesDialogHeaderComponentProps) => (
  <DialogHeader>
    <DialogTitle
      className={cn("text-xl font-medium text-gray-800", {
        "text-destructive": variant === "destructive",
      })}
    >
      {title}
    </DialogTitle>
  </DialogHeader>
);

export const ProjectSchedulesDialogHeader = memo(
  ProjectSchedulesDialogHeaderComponent,
);
